/*
  Pages anyone can open without an account: Discover, the blog, About us and a
  product's page (paying still needs an account). Every other page asks a
  signed-out visitor to sign in or join, in a popup.
*/
const PUBLIC_PATHS = [
  /^\/$/, // Discover
  /^\/resources(\/.*)?$/, // Blog, news articles, About us
  /^\/mint-space\/[^/]+\/product(\/[^/]+)?\/?$/, // Product page
  /^\/auth(\/callback)?\/?$/,
  /^\/r\/[^/]+\/?$/, // Affiliate links forward on to the space
  /^\/invite\/[^/]+\/?$/,
  /^\/admin(\/.*)?$/, // Admin panel has its own sign-in
];

/** True when `to` (a path, with or without ?query / #hash) can be opened signed out. */
export function isPublicPath(to) {
  const pathname = String(to || "").split(/[?#]/)[0] || "/";
  return PUBLIC_PATHS.some((pattern) => pattern.test(pathname));
}
